import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { Account } from '../../../clients'

type AccountType = Omit<Account, 'createdAt' | 'updatedAt' | 'lastSeenDate'> & { createdAt: string, updatedAt: string, lastSeenDate: string }

interface CurrentUserState {
  account: AccountType | null
}

const initialState: CurrentUserState = {
  account: null
}

const currentUserSlice = createSlice({
  name: 'currentUser',
  initialState,
  reducers: {
    setCurrentUser(state, payload: PayloadAction<AccountType | null>) {
      state.account = payload.payload
    },
  }
})

export const { setCurrentUser } = currentUserSlice.actions
export default currentUserSlice.reducer